import { render, staticRenderFns } from "./ListHistoryContact.vue?vue&type=template&id=c3680266&scoped=true"
import script from "./ListHistoryContact.vue?vue&type=script&lang=js"
export * from "./ListHistoryContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3680266",
  null
  
)

export default component.exports